<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Discipline Records</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div>
              <add-discipline-record v-if="pagepermission.insertable" @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedCategory"
                placeholder="Category"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleCategoryChange"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Category</a-select-option>
                <template v-for="category in categories">
                  <a-select-option :value="category.id" :key="category.id">
                  {{category.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <div class="col-md-3 col-12 mb-2">
            <a-range-picker
            v-model="selectedDate"
              size="large"
              style="width: 100%"
              :format="dateFormat"
              @change="handleDateSelect"
              :disabledDate="disabledDate"
              :placeholder="['Start Date', 'End Date']"
            />
          </div>
            <div class="col-md-2 col-12 mb-2">
                <a-select
                size="large"
                v-model="selectedSeverity"
                placeholder="Severity"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSeverityChange"
                :filterOption="false"
                >
                <a-select-option :value="undefined">All Severity</a-select-option>
                <template v-for="severity in severity">
                  <a-select-option :value="severity" :key="severity">
                  {{severity}}
                  </a-select-option>
                </template>
                </a-select>
            </div>
          <!-- Penalty Type Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedPenalty"
              placeholder="All Penalties"
              optionFilterProp="children"
              style="width: 100%"
              @change="handlePenaltyChange"
              :filterOption="false"
            >
              <a-select-option :value="undefined">All Penalties</a-select-option>
              <template v-for="penalty in penalties">
                <a-select-option :value="penalty.id" :key="penalty.id">
                  {{penalty.name}}
                </a-select-option>
              </template>
            </a-select>
          </div>

            <!-- Student Search -->
          <div class="col-md-4 mb-2" v-if="!selectedRowKeys.length">
            <div class="text-right">
              <a-input-search
                placeholder="Search Students.."
                size="large"
                v-model="search"
                @search="searchDisciplineRecords"
                @change="searchDisciplineRecords"
              />
            </div>
          </div>

          <div class="col-md-6 col-12 mb-2 text-md-right" v-else-if="pagepermission.deletable" >
            <a href="javascript:;" class="btn btn btn-danger btn-with-addon"
              @click="handleDeleteSelected"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete Selected
            </a>
          </div>

      </div>
        <div class="card">
          <div class="card-body">
            <discipline-records-table
              :rolesetting="pagepermission"
              :data="data"
              :loading="loading"
              :session="selectedSession"
              :classMap="classMap"
              @updateTable="handleUpdateTable"
              @selectChange="handleTableSelect"
            />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DisciplineRecordsTable from '@/components/disciplineManagement/disciplineRecords/Table'
import AddDisciplineRecord from '@/components/disciplineManagement/Form/Add'
import moment from 'moment'

import { debounce, find } from 'lodash'
// const pagename = 'student'
export default {
  components: {
    DisciplineRecordsTable,
    AddDisciplineRecord,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('student', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.getDisciplineRecords()
        this.getCategories()
        this.getPenalties()
      })
      .catch(error => {
        console.log(error)
        this.$neoNotify.error(error)
      })
  },
  created() {
    this.searchDisciplineRecords = debounce(this.searchDisciplineRecords, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      categories: [],
      penalties: [],
      schoolSessions: [],
      current: 1,
      pageSize: 10,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedCategory: undefined,
      selectedSeverity: undefined,
      selectedPenalty: undefined,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      severity: ['minor', 'medium', 'major'],
      dateFormat: 'YYYY-MM-DD',
      selectedDate: null,
      sorterField: null,
      sorterOrder: null,
      filters: [],
      classMap: {},
      permissionCheckSpinning: true,
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    getDisciplineRecords: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/student-discipline', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
          start_date: this.selectedDate ? moment(this.selectedDate[0]).format('YYYY-MM-DD') : undefined,
          end_date: this.selectedDate ? moment(this.selectedDate[1]).format('YYYY-MM-DD') : undefined,
          category_id: this.selectedCategory,
          severity: this.selectedSeverity,
          penalty_id: this.selectedPenalty,
          sorter_field: this.sorterField,
          sorter_order: this.sorterOrder,
          ...this.filters,
        },

      }).then(({ data }) => {
        this.loading = false
        this.data = data.data.map(item => {
          const enrollment = item.student && item.student.enrollment && item.student.enrollment.length
            ? item.student.enrollment[0]
            : null
          const classId = enrollment ? enrollment.class_id : null
          const sectionName = enrollment && enrollment.section ? enrollment.section.name : null
          const sectionId = enrollment && enrollment.section ? enrollment.section.id : null
          // FIX: Better class name lookup with fallback
          let className = '-'
          if (classId) {
            className = this.classMap[classId] || '-'
          }

          // DEBUG: Log if class mapping fails
          if (classId && !this.classMap[classId]) {
            console.warn(`Class ID ${classId} not found in classMap. Available classes:`, Object.keys(this.classMap))
          }
          return {
            id: item.id,
            incident_date: item.incident_date,
            student_name: item.student ? `${item.student.first_name} ${item.student.last_name}` : '-',
            student_id: item.student_id,
            class_name: className,
            class_id: classId,
            section_name: sectionName,
            section_id: sectionId,
            category_name: item.category ? item.category.name : '-',
            category_id: item.category_id,
            description: item.description || '-',
            penalty: item.penalty ? item.penalty.name : '-',
            penalty_id: item.penalty_id,
            penalty_details: item.penalty_details || '-',
            severity: item.severity || '-',
            reported_by: item.reported_by
              ? `${item.reported_by.first_name} ${item.reported_by.last_name}`
              : '-',
            reported_by_id: item.reported_by ? item.reported_by.id : null,
            student_code: item.student ? item.student.student_code : '-',
            roll_no: enrollment ? enrollment.roll_no : '-',
          }
        })
        this.meta = data.meta
      }
      ).catch(error => {
        this.loading = false
        console.log(error)
        this.$neoNotify.error(error)
      })
    },
    getCategories() {
      this.$http.get('/api/student-discipline-category')
        .then(({ data }) => {
          this.categories = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    getPenalties() {
      this.$http.get('/api/discipline-penalty')
        .then(({ data }) => {
          this.penalties = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchDisciplineRecords: function(e) {
      this.search = e.target.value
      this.getDisciplineRecords(true)
    },
    handleCreated: function() {
      this.getDisciplineRecords()
    },
    handleUpdateTable: function(args) {
      console.log('args', args)
      if (args !== undefined && args !== null && args.length > 0) {
        this.sorterField = args[0]
        this.sorterOrder = args[1]
        this.filters = args[2]
      }
      this.getDisciplineRecords()
    },
    handleDateSelect(dates) {
      this.selectedDate = dates
      this.getDisciplineRecords(true)
    },

    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },

    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getDisciplineRecords()
    },
    onChange(current) {
      this.current = current
      this.getDisciplineRecords()
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data

          // REBUILD classMap properly
          this.classMap = {}
          data.data.forEach(cls => {
            this.classMap[cls.id] = cls.name
          })

          console.log('ClassMap rebuilt:', this.classMap) // Debug log
          this.classSpinning = false

          // Refresh the table to use the updated classMap
          this.getDisciplineRecords()
        })
        .catch(error => {
          console.log(error)
          this.classSpinning = false
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.getDisciplineRecords()
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getDisciplineRecords()
      } else {
        this.selectedSection = undefined
        this.getDisciplineRecords()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getDisciplineRecords()
    },
    handleCategoryChange(value) {
      this.selectedCategory = value
      this.getDisciplineRecords(true)
    },

    handleSeverityChange(value) {
      this.selectedSeverity = value
      this.getDisciplineRecords(true)
    },

    handlePenaltyChange(value) {
      this.selectedPenalty = value
      this.getDisciplineRecords(true)
    },

    handleDeleteSelected() {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete the selected students?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student-discipline', {
              params: {
                student_ids: this.selectedRowKeys,
              },
            })
            .then(() => {
              this.handleUpdateTable()
              this.selectedRowKeys = []
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The selected students were deleted successfully',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
<style scoped>
.error { padding: 25px 5px; }
</style>
